import Icon from "components/icon";
import { toCurrency } from "helpers/utils";
import CompetitorCard from "components/league/CompetitorCard";
import RankUserCard from "components/league/RankUserCard";
import * as _ from "lodash";
import moment, { ISO_8601 } from "moment";
import { useEffect, useReducer, useState } from "react";
import toast from "react-hot-toast";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import leageRankImage from "statics/images/leage-rank-img.png";
import {
  TEModal,
  TEModalBody,
  TEModalContent,
  TEModalDialog,
  TETabs,
  TETabsContent,
  TETabsItem,
  TETabsPane,
} from "tw-elements-react";
import CompetitorCheckinCard from "../../components/league/CompetitorCheckinCard";
import PlayerLeagueProgress from "../../components/league/PlayerLeagueProgress";
import Navbar from "../../components/navbar";
import DeLeagueLive from "./de/live";
import SwissLeagueLive from "./swiss/live";
import * as SBService from "../../helpers/sportbookService";
import LeagueInterface, { defaultLeague } from "../../interfaces/league";
import { bottomBarState, loaderState, userState } from "../../states/common";

import { COT_BXH } from "components/league/rankColumns";
const TYPE_LABEL: Record<string, string> = {
  "ROUND-ROBIN": "Vòng tròn",
  ELIMINATION: "Loại trực tiếp",
  TEAM: "Đồng đội",
  MASTER: "Master",
  SWISS: "Swiss",
};
const moneyVi = (v: any) => {
  const n = Number(String(v ?? "").replace(/\D/g, ""));
  return isNaN(n) ? v : n.toLocaleString("vi-VN");
};

const LeagueStandingPage = () => {
  const [user, setUser] = useRecoilState(userState);
  const [active, setActive] = useRecoilState(bottomBarState);
  let [players, setPlayers] = useState<any>([]);
  let [userInLeague, setUserInLeague] = useState<any>({});
  // Đã đăng ký nhưng ban tổ chức chưa xác nhận đóng phí: chưa được xếp lịch,
  // chưa check-in được - chỉ thấy thông tin giải và lời nhắc đóng phí.
  const [waitingFee, setWaitingFee] = useState(false);
  const [feeAmount, setFeeAmount] = useState<number | null>(null);
  let [playerCheckin, setPlayerCheckin] = useState<any>({});
  let [currentTime, setCurrentTime] = useState<any>(moment());
  const [, setLoader] = useRecoilState(loaderState);
  const { id } = useParams();
  const navigate = useNavigate();

  const [totalWeek, setTotalWeek] = useState<any>(0);
  const [currentWeek, setCurrentWeek] = useState<any>(0);
  const [currentViewWeek, setCurrentViewWeek] = useState<any>(0);
  const [isCompleteMinRequired, setIsCompleteMinRequired] =
    useState<boolean>(false);
  const [totalComplete, setTotalComplete] = useState<number>(0);

  const [basicActive, setBasicActive] = useState("play"); // đã đăng ký → mặc định tab Thi đấu
  const handleBasicClick = (value: string) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [address, setAddress] = useState("");
  const [league, setLeague] = useState<LeagueInterface>(defaultLeague);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.title = "Biadi — Chi tiết giải";
    setActive("league");
    const loadData = async function () {
      setLoader(true);
      getLeagueData();
      setLoader(false);
    };
    loadData();
  }, []);

  const getLeagueData = async () => {
    try {
      let leagueData;
      const rsp = await SBService.getLeagueById(id);
      leagueData = rsp;
      if (rsp.data) {
        leagueData = rsp.data;
      }
      if (leagueData) {
        /* Swiss và Đấu kép là hai loại giải tự dựng cả trang (kể cả màn chưa đăng
           ký): render ngay tại đây thay vì điều hướng sang URL riêng. Chỉ cần set
           league để render rẽ nhánh, và DỪNG LẠI - mấy dòng *Obj bên dưới là của
           màn giải thường, hai trang này không đọc chúng. */
        if (leagueData.type === "SWISS" || leagueData.type === "DOUBLE-ELIMINATION") {
          setLeague(leagueData);
          return;
        }
        if (leagueData.startDate) {
          leagueData.startDateObj = moment(leagueData.startDate, ISO_8601);
          leagueData.endDateObj = moment(leagueData.endDate, ISO_8601).endOf('day');
          leagueData.startRegistrationDateObj = moment(
            leagueData.startRegistrationDate,
            ISO_8601
          );
          leagueData.endRegistrationDateObj = moment(
            leagueData.endRegistrationDate,
            ISO_8601
          ).endOf('day');
          const totalWeekCalculated = Math.ceil(
            leagueData.endDateObj.diff(leagueData.startDateObj, "days") / 7
          );
          setTotalWeek(totalWeekCalculated);
          const diffDateCurrent = currentTime.diff(
            leagueData.startDateObj,
            "days"
          );
          if (diffDateCurrent < 0) {
            setCurrentWeek(0);
            setCurrentViewWeek(0);
          } else if (diffDateCurrent === 0) {
            setCurrentWeek(1);
            setCurrentViewWeek(1);
          } else {
            const week = Math.ceil((diffDateCurrent + 1) / 7);
            setCurrentWeek(week);
            if (week > totalWeekCalculated) {
              setCurrentViewWeek(totalWeekCalculated);
            } else {
              setCurrentViewWeek(week);
            }
          }
        }
        setLeague(leagueData);
        // Danh sách cơ thủ và danh sách check-in chỉ là phần phụ: hỏng thì báo
        // một câu, đừng để catch bên dưới đá người xem ra khỏi trang giải.
        try {
          await loadPlayers();
        } catch (e: any) {
          toast.error("Không tải được danh sách cơ thủ");
        }
        try {
          await loadCheckedInPlayer();
        } catch (e: any) {
          toast.error("Không tải được danh sách check-in");
        }
      }
      if (leagueData.venues) {
        setAddress(leagueData.venues.map((venue: any) => venue.name).join(","));
      }
    } catch (e: any) {
      // Chỉ quay lại khi chính giải đấu không tải được.
      navigate(-1);
    }
    forceUpdate();
  };

  let [, setCurrentPage] = useState(1);
  let [, setIsPlayerNextPage] = useState(true);

  const loadPlayers = async (page: number = 1) => {
    const leaguePlayers = await SBService.getLeaguePlayersById(id, 50, page);
    if (leaguePlayers.data) {
      if (page === 1) {
        players = leaguePlayers.data;
      } else {
        players = players.concat(leaguePlayers.data);
      }
      // Hỏi trạng thái đăng ký trước: chưa đăng ký thì bỏ qua luôn phần "của
      // bạn", khỏi bắn một request chỉ để nhận 404 playerNotInLeague. Backend
      // cũ chưa có endpoint này thì rơi về cách gọi cũ.
      const myStatusRsp: any = await SBService.getMyLeagueStatus(id ?? "").catch(() => null);
      const myStatus = myStatusRsp?.data ?? myStatusRsp;
      if (myStatus) {
        setWaitingFee(myStatus.state === "waiting_fee");
        setFeeAmount(myStatus.fee ?? null);
      }
      if (myStatus && myStatus.registered === false) {
        setPlayers(players);
        if (leaguePlayers.hasNextPage) {
          setCurrentPage(leaguePlayers.page);
          setIsPlayerNextPage(leaguePlayers.hasNextPage);
        }
        forceUpdate();
        return;
      }

      // Vẫn giữ bọc 404: đăng ký có thể bị ban tổ chức xoá giữa chừng.
      try {
        const userRec = await SBService.getPlayerInLeagueData(id, user.id);
        if (userRec.data && userRec.data.leaguePlayerWeek.length > 0) {
          let totalComplete = 0;
          try {
            userRec.data.leaguePlayerWeek.forEach((week: any) => {
              if (week.isClaimedMinRequiredMatch) totalComplete++;
            });
          } catch (e: any) {
            console.log(e);
          }
          setTotalComplete(totalComplete);
        }
        setUserInLeague(userRec.data);
      } catch (e: any) {
        if (e?.response?.status !== 404) throw e;
      }
      setPlayers(players);
      if (leaguePlayers.hasNextPage) {
        setCurrentPage(leaguePlayers.page);
        setIsPlayerNextPage(leaguePlayers.hasNextPage);
      }
    }
    forceUpdate();
  };

  const loadCheckedInPlayer = async (page = 1) => {
    const leaguePlayers = await SBService.getCheckinListByLeagueId(
      id,
      50,
      page
    );
    if (leaguePlayers.data) {
      if (page === 1) {
        playerCheckin = leaguePlayers.data;
      } else {
        playerCheckin = playerCheckin.concat(playerCheckin.data);
      }
      setPlayerCheckin(playerCheckin);
    }
  };

  const updateIndexOfViewWeek = (index: number) => {
    setCurrentViewWeek(index + 1);
  };

  const renderWeekListing = () => {
    return [...Array(totalWeek)].map((x, i) => (
      <PlayerLeagueProgress
        key={`league-progress-${i}`}
        league={league}
        playerLeagueWeek={userInLeague.leaguePlayerWeek.find(
          (lpWeek: any) => lpWeek.week === i + 1
        )}
        startOfWeek={league.startDateObj.clone().add(i, "week").format("DD/MM")}
        endOfWeek={league.startDateObj
          .clone()
          .add(i + 1, "week")
          .subtract(1, "day")
          .format("DD/MM")}
        state={
          i + 1 < currentWeek
            ? "pass"
            : i + 1 === currentWeek
            ? "running"
            : "waiting"
        }
      />
    ));
  };

  const hideGlobalShowModel = () => {
    setShowModal(false);
  };

  const leaveLeague = async (leagueId: string, userId: string) => {
    try {
      await SBService.leaveLeague(leagueId, userId);
      setUserInLeague(null);
      toast.success("Rời khỏi giải thành công");
      window.location.reload();
      setUser((prevUser) => {
        const updatedLeagues = prevUser.leagues.filter(
          (league) => league.id !== leagueId
        );
        return { ...prevUser, leagues: updatedLeagues };
      });
    } catch (e: any) {
      toast.error("Rời khỏi giải thất bại");
    }
  };

  useEffect(() => {
    if (league.id && totalComplete) {
      if (totalComplete > league.minWeekReachMinMatchesRequired) {
        setIsCompleteMinRequired(true);
      }
    }
  }, [league, totalComplete]);

  const checkIn = async () => {
    setLoader(true);
    try {
      await SBService.checkinLeagueById(league.id);
      setUserInLeague({ ...userInLeague, ...{ isCheckin: true } });
      toast.success("Check-In thành công");
      await loadCheckedInPlayer(1);
    } catch (e: any) {
      toast.error("Check-In thất bại");
    }
    setLoader(false);
  };

  const checkOut = async () => {
    setLoader(true);
    try {
      await SBService.checkoutLeagueById(league.id);
      setUserInLeague({ ...userInLeague, ...{ isCheckin: false } });
      toast.success("Check-out thành công");
      await loadCheckedInPlayer(1);
    } catch (e: any) {
      toast.error("Check-out thất bại");
    }
    setLoader(false);
  };

  if (league.type === "SWISS") {
    return <SwissLeagueLive leagueId={id ?? ""} />;
  }

  if (league.type === "DOUBLE-ELIMINATION") {
    return <DeLeagueLive leagueId={id ?? ""} />;
  }

  if (!league.id) {
    return <div className="biadi" style={{ minHeight: "100vh" }} />;
  }

  return (
    <div className="biadi">
      <div className="navbar">
        <button className="back" onClick={() => navigate(-1)}>‹</button>
        <span className="ttl">Thông tin giải đấu</span>
      </div>
      <div className="pad">
        <div className="cover">
          <span className="fmt chip solid">{TYPE_LABEL[league.type || ""] || league.type}</span>
          <div className="cvin">
            <div className="big">{league.name}</div>
            <div className="sub">Rank • Compete • Trust</div>
          </div>
        </div>
        <h1 className="jname">{league.name}</h1>
        <div className="metarow" style={{ marginTop: 8 }}>
          <span>{TYPE_LABEL[league.type || ""] || league.type}</span>
          <span className="dot" />
          <span>{league.startDateObj.format("DD/MM")} – {league.endDateObj.format("DD/MM/YYYY")}</span>
          {league.fee ? (
            <>
              <span className="dot" />
              <span>Lệ phí {moneyVi(league.fee)} đ</span>
            </>
          ) : null}
        </div>

        <div className="tabs">
          <button className={basicActive === "info" ? "on" : ""} onClick={() => handleBasicClick("info")}>Thông tin chung</button>
          <button className={basicActive === "play" ? "on" : ""} onClick={() => handleBasicClick("play")}>Thi đấu</button>
          <button className={basicActive === "rank" ? "on" : ""} onClick={() => handleBasicClick("rank")}>BXH</button>
        </div>

        <div className="tabpane">
          {basicActive === "info" && (
            <>
              <div className="sec">
                <div className="infoline"><div className="ic">📅</div><div><div className="k">Đăng ký</div><div className="v acc">{league.startRegistrationDateObj.format("DD/MM")} – {league.endRegistrationDateObj.format("DD/MM/YYYY")}</div></div></div>
                <div className="divider" />
                <div className="infoline"><div className="ic">🎱</div><div><div className="k">Thi đấu</div><div className="v">{league.startDateObj.format("DD/MM")} – {league.endDateObj.format("DD/MM/YYYY")}</div></div></div>
              </div>
              {league.leaguePrizes && league.leaguePrizes.length > 0 ? (
                <>
                  <div className="jhead">Giải thưởng</div>
                  <div className="sec">
                    <div className="prizehead"><span>Thứ hạng</span><span style={{ textAlign: "right" }}>Tiền mặt</span><span>Hiện vật</span></div>
                    {league.leaguePrizes.map((p: any, i: number) => (
                      <div key={i} className="prizerow"><span className="p1">{p.label}</span><span className="p2">{p.prizeInCash ? `${moneyVi(p.prizeInCash)} đ` : "—"}</span><span className="small">{p.prizeInKind || "—"}</span></div>
                    ))}
                  </div>
                </>
              ) : null}
              <div className="jhead">Thể lệ thi đấu</div>
              <div className="sec rulebody">
                {league.rule ? (
                  <div className="raw-css" dangerouslySetInnerHTML={{ __html: league.rule }} />
                ) : (
                  <div className="tiny">Ban tổ chức chưa công bố thể lệ chi tiết.</div>
                )}
              </div>
            </>
          )}

          {basicActive === "rank" && (
            <>
              {waitingFee ? (
                <div className="sec" style={{ padding: "14px 12px" }}>
                  <div className="jhead" style={{ marginTop: 0 }}>Chờ xác nhận đóng phí</div>
                  <div className="tiny">
                    Bạn đã đăng ký giải{feeAmount ? ` (phí ${toCurrency(feeAmount)} vnđ)` : ""}. Sau khi ban tổ chức xác nhận đã đóng phí, bạn mới vào danh sách chính thức và có lịch thi đấu.
                  </div>
                </div>
              ) : userInLeague?.id && league.startDateObj.diff(currentTime) <= 0 ? (
                <div className="flex p-2 rounded-[0.5rem] overflow-hidden relative mt-2 z-0 bg-[#902416]">
                  <div className="w-full relative z-10 ">
                    <RankUserCard player={userInLeague} index={userInLeague.leaguePosition} />
                  </div>
                  <img className="absolute right-0 top-0 z-0 mix-blend-multiply h-full" src={leageRankImage} />
                </div>
              ) : null}
              {/* Bề rộng cột lấy từ COT_BXH — cùng nguồn với CompetitorCard,
                  nên tiêu đề không thể lệch khỏi hàng dữ liệu nữa. */}
              <div className="flex mt-3">
                {league.startDateObj.diff(currentTime) > 0 ? (
                  <span className={`uppercase text-sm opacity-70 ${COT_BXH.chuaBatDau.ten}`}>Cơ thủ</span>
                ) : (
                  <>
                    <span className={`uppercase text-sm opacity-70 ${COT_BXH.dayDu.rank} pl-3`}>#</span>
                    <span className={`uppercase text-sm opacity-70 ${COT_BXH.dayDu.ten}`}>Cơ thủ</span>
                  </>
                )}
                <span className={`uppercase text-sm opacity-70 ${COT_BXH.dayDu.hang}`}>Hạng</span>
                <span className={`uppercase text-sm opacity-70 ${COT_BXH.dayDu.doiDau}`}>Đối đầu</span>
                {/* Ô trống giữ chỗ cho cột nút mở rộng của hàng dữ liệu. */}
                {league.startDateObj.diff(currentTime) > 0 ? null : (
                  <span className={COT_BXH.dayDu.nut} aria-hidden="true" />
                )}
              </div>
              <div className="league-player overflow-auto">
                {!_.isEmpty(players)
                  ? players.map((player: object, index: number) => {
                      if (!_.isEmpty(player))
                        return (
                          <CompetitorCard
                            key={`player-leagues-${index}`}
                            player={player}
                            index={index}
                            leagueId={league.id}
                            hideCountMatch={league.startDateObj.diff(currentTime) > 0}
                            listPlayer={players}
                          />
                        );
                      return null;
                    })
                  : ""}
              </div>
            </>
          )}

          {basicActive === "play" && (
            <div className="font-exo">
              {currentWeek > 0 && league && league.id && userInLeague && userInLeague.id && league.minMatchesPerWeek ? (
                <div className="rounded bg-[#131A28] mt-2 px-2 py-4 box-border flex flex-wrap">
                  <div className="w-1/2 pl-4"><span className="uppercase opacity-70">tiến độ TUẦN</span></div>
                  <div className="w-1/2 text-right pr-4"><span className=" opacity-70">Tuần </span><span>{currentViewWeek}/{totalWeek}</span></div>
                  <div className="wrapper-slider-week-progress w-full">
                    <Carousel className="overflow-hidden w-full league-standing-carousel py-2" showIndicators={false} showStatus={false} showArrows={true} autoPlay={false} showThumbs={false} selectedItem={currentViewWeek - 1} onChange={(index, item) => updateIndexOfViewWeek(index)}>
                      {renderWeekListing()}
                    </Carousel>
                    <div className="px-11 mt-2 font-exo font-bold">
                      <span className={isCompleteMinRequired ? "text-[#902416]  bg-[#F2F3EF] rounded-full" : "text-[#8B92A6]  bg-[#F2F3EF] rounded-full"}>
                        <Icon size={"xl"} icon={"fa-circle-dot"} />
                      </span>
                      <span className="text-[#8B92A6] ml-2">Đủ điều kiện nhận cọc</span>{" "}
                      <span className="text-[#902416] rounded-full border border-[#902416] inline-block px-2" onClick={() => setShowModal(true)}>
                        <Icon size={"xs"} icon={"fa-question"} />
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
              {waitingFee ? (
                <div className="text-center text-[#8B92A6] py-2 mt-3">Bạn chưa được xác nhận đóng phí nên chưa thể check-in.</div>
              ) : !userInLeague?.id ? (
                <div className="text-center text-[#8B92A6] py-2 mt-3">Bạn chưa đăng ký giải này nên chưa thể check-in.</div>
              ) : userInLeague.isCheckin ? (
                <button className="btn w-full btn-primary text-chalk py-2 heading-6 uppercase mt-3" onClick={() => checkOut()}>Check-Out</button>
              ) : (
                <button className="btn w-full btn-primary text-chalk py-2 heading-6 uppercase mt-3" onClick={() => checkIn()}>Check-In</button>
              )}
              <div className="mt-4 text-sm">
                <div className="flex font-bold">
                  {league.startDateObj.diff(currentTime) > 0 ? (
                    <span className="uppercase text-sm opacity-70 w-[60%]">Cơ thủ</span>
                  ) : (
                    <>
                      <span className="uppercase text-sm opacity-70 w-[20%] pl-3">#</span>
                      <span className="uppercase text-sm opacity-70 w-[40%]">Cơ thủ</span>
                    </>
                  )}
                  <span className="uppercase text-sm opacity-70 w-[20%]">Hạng</span>
                  <span className="uppercase text-sm opacity-70 w-[20%]">số trận</span>
                </div>
                <div className="league-player overflow-auto">
                  {!_.isEmpty(playerCheckin)
                    ? playerCheckin.map((player: object, index: number) => {
                        if (!_.isEmpty(player))
                          return (
                            <CompetitorCheckinCard
                              key={`player-checkin-leagues-${index}`}
                              player={player}
                              index={index}
                              leagueId={league.id}
                              listPlayer={playerCheckin}
                            />
                          );
                        return null;
                      })
                    : ""}
                </div>
              </div>
            </div>
          )}
        </div>

        {league && league.startDateObj.diff(currentTime) > 0 && userInLeague?.id && (
          <div className="flex w-full mt-3">
            <button className="block w-full h-12 text-[#C13A28] text-center text-base rounded font-medium font-exo" onClick={() => leaveLeague(league.id, user.id)}>
              Rút khỏi giải
            </button>
          </div>
        )}
      </div>

      <TEModal className="zIndexTop" show={showModal} setShow={setShowModal}>
        <TEModalDialog className="h-full" centered={true}>
          <TEModalContent>
            <TEModalBody className="bg-[#131A28] text-center border border-[#242D40] rounded">
              <div className="w-full text-left border border-dotted rounded-[0.5rem] py-2 px-4 border-[#4D3000] bg-[#16120C]">
                <p className="font-exo text-sm font-medium uppercase text-[#FFE7B3]">ĐIỀU KIỆN NHẬN CỌC</p>
                <div className="font-exo text-[#FFCA16] text-[14px]">
                  Bạn cần tham gia đủ {league.minMatchesPerWeek} trận đấu mỗi tuần trong {league.minWeekReachMinMatchesRequired} tuần để nhận lại cọc.
                </div>
              </div>
              <div className="flex">
                <button onClick={() => hideGlobalShowModel()} className="block w-full h-12 btn-primary text-center text-lg button-custom-shadow mt-6 mr-2">
                  {"đã hiểu"}
                </button>
              </div>
            </TEModalBody>
          </TEModalContent>
        </TEModalDialog>
      </TEModal>
    </div>
  );
};

export default LeagueStandingPage;
